import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultarDatosUsuario_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultarDatosUsuario",
    rutaEndPoint: "/EnterpriseServices/Sel/Cuenta/consultarDatosUsuario",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface ConsultarDatosUsuario_Entrada {
  username: string;
}

export function builtConsultarDatosUsuario_Entrada(p_username: string) {
  var retorno: ConsultarDatosUsuario_Entrada = {
    username: p_username,
  };

  return retorno;
}

//SALIDA
export interface ConsultarDatosUsuario_Salida {
  respuesta: string;
  respuestadesc: string;
  USERID: string;
  USERNAME: string;
  NOMBRE_COMPLETO: string;
  EMAIL: string;
  CTASKY: string;
  TIPO_CUENTA: string;
  PERMISOS: null;
  NombreCorp: null;
  PRIMER_SESION: null;
}

export type ConsultarDatosUsuario_Respuesta = ConsultarDatosUsuario_Salida;
